import loadable from '@loadable/component';
import React from 'react';
import { ProductPropertiesProps } from './types';

const LoadableComponent = loadable(() =>
  import(/* webpackChunkName: "product" */ './product-properties')
);

const ProductPropertiesLoader = (props: ProductPropertiesProps) => {
  if (!props.properties || !props.properties.nodes) {
    return null;
  }

  return <LoadableComponent {...props} />;
};

export default ProductPropertiesLoader;
